import { render, staticRenderFns } from "./MyDates.vue?vue&type=template&id=5a8c2fcd&"
import script from "./MyDates.vue?vue&type=script&setup=true&lang=js&"
export * from "./MyDates.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MyDates.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports